<div class="max-page-width">

  <div class="col-lg-12 col-md-12 my-bookings my-favourits">
    <h1>{{ 'MyFavourits' | translate  }}</h1>

    <div class="row">
      <div class="col-lg-10 col-md-12">
        <div *ngFor="let vehicle of vehicles; let i = index">



          <div class="cardVehicle">
  
            <!-- make/model/year -->
            <div *ngIf="vehicle.makeModelYearSearch">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="car-image">
                    <img class="img-fluid"
                    [src]="attachmentService
                    .getMMYCarImageLink(vehicle.modelID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.MMYImage,vehicle.makeID,vehicle.modelID,vehicle.year)"
                    [alt]="vehicle.vehicleName"
                      (click)="onVehicleImageClicked(vehicle)">
                  </div>
                  <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                    <div class="car-details d-flex">
                      <div class="car-rank"><span class="badge badge-pill badge-primary">
                          <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                        <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                      <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                      </div>
                    </div>
                  </button>
                </div>
                <div class="col-lg-6  col-md-6 col-12 border-right">
                  <div class="d-flex">
                    <div class="vehicle-name mr-auto">
                      {{vehicle.vehicleName}}
                    </div>
                    <div class="vehicle-top-list  d-flex align-items-top">
                      <div class="vehicle-class">
                        {{vehicle.vehicleClass}}
                      </div>
                    </div>
                  </div>
                  <!-- <div class="vehicle-class">
                  {{vehicle.vehicleClass}}
                </div> -->
                  <div class="vehicle-features">
                    <div class="row mt-2">
                      <!-- vehicle Gear Type-->
                      <div class="col-md-4 mt-2 col-4 d-flex  align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
                        </span>
                        <div>
                          <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                            <li>{{gearType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Condition Unit -->
                      <!--   <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                      <span><mat-icon class="fa-s">ac_unit</mat-icon></span>
                      <div>
                        <ul *ngFor="let conditionUnit of vehicle.vehicleConditionUnit" class="vehicle-inner-list">
                          <li>{{conditionUnit}}</li>
                        </ul>
                      </div>
                    </div> -->
  
                      <!-- vehicle Petrol Type -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faGasPump"></fa-icon>
                        </span>
                        <div>
                          <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                            <li>{{petrolType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Passengers Number -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faUser"></fa-icon>
                        </span>
                        <div>
                          <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                            <li>{{passengersNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Doors Number -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
                        </span>
                        <div>
                          <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                            <li>{{doorsNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Storage -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <mat-icon ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                            class="fa-s luggage mr-1">luggage</mat-icon>
                        </span>
                        <div>
                          <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                            <li>{{storage}}</li>
                          </ul>
                        </div>
                      </div>
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <div class="car-colors  justify-content-center">
                          <div class="d-flex">
                            <div class="d-flex" style="float: left;" *ngFor="let color of vehicle.vehicleColors; let i = index">
                              <span *ngIf="i < 4">
                                <span class="color-box mr-1 d-flex" [style.backgroundColor]="color.ExtericColor "></span>
                              </span>
                            </div>
                            <div  *ngFor="let color of vehicle.vehicleColors; let i = index">
                              <span *ngIf="i == 4 && vehicle.vehicleColors.length > 4">
                                <a class="" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample"><i class="far fa-plus-square color-expand"></i></a>
                              </span>
                            </div>
                          </div>
  
                          <div class="collapse" id="collapseExample">
                            <ul>
                              <li class="d-inline" *ngFor="let color of vehicle.vehicleColors; let i = index">
  
                                <div *ngIf="i > 4">
                                  <div class="color-box mr-1" [style.backgroundColor]="color.ExtericColor "></div>
                                </div>
  
                              </li>
                            </ul>
                          </div>
  
                        </div>
                      </div>
  
                    </div>
                    <div class="row mb-3 mt-2">
                      <div class="col-md-12 d-flex location-line align-items-top">
                        <fa-icon ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s"
                          [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.fromAgencyName}} - {{vehicle.vehicleLocation}}
                      </div>
                    </div>
  
  
                    <div class="promotion-box mb-3" *ngIf="vehicle.campaignsReservationCaseModel!=null&&vehicle.campaignsReservationCaseModel.campaignName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" [attr.data-target]="'#collapseExample1_'+i" [attr.aria-controls]="'collapseExample1_'+i" aria-expanded="false" >
                        <i class="fas fa-gift promotion-icon mr-1 mt-1"></i> {{vehicle.campaignsReservationCaseModel.campaignName}}: {{'Expires' | translate}} {{vehicle.campaignsReservationCaseModel.endDateFormated}} {{vehicle.campaignsReservationCaseModel.discount}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample1_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.campaignsReservationCaseModel.campaignAdditionalServices!=null&&vehicle.campaignsReservationCaseModel.campaignAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5  *ngIf="vehicle.campaignsReservationCaseModel.campaignFreePolicies!=null&&vehicle.campaignsReservationCaseModel.campaignFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="promotion-box mb-3" *ngIf="vehicle.membershipModel!=null&&vehicle.membershipModel.membershipName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" data-toggle="collapse" [attr.data-target]="'#collapseExample1_'+i" [attr.aria-controls]="'collapseExample1_'+i" aria-expanded="false">
                        <i class="fas fa-award promotion-icon mr-1 mt-1"></i> {{vehicle.membershipModel.membershipName}} {{ 'Membership' | translate }} : {{ 'Discount' | translate }}  {{vehicle.membershipModel.discountValue}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample1_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.membershipModel.lstMembershipAdditionalServices!=null&&vehicle.membershipModel.lstMembershipAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstMembershipAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5 *ngIf="vehicle.membershipModel.lstCustomerMembershipFreePolicies!=null&&vehicle.membershipModel.lstCustomerMembershipFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstCustomerMembershipFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <policies-icons [policyRequestModel]="vehicle"></policies-icons>
  
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="d-flex">
                    <div class="favorite ml-auto" >
                      <button mat-icon-button (click)="toggleFavorite(vehicle)">
                        <mat-icon [ngClass]=" vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                          *ngIf="vehicle.isFavorite">favorite</mat-icon>
                        <mat-icon [ngClass]=" !vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                          *ngIf="!vehicle.isFavorite">favorite_border</mat-icon>
                      </button>
                    </div>
  
                    <!-- <div><fa-icon class="mr-1 grey"   ngbPopover="{{ 'TotalRental' | translate }}" triggers="mouseenter:mouseleave" [icon]="faKey"></fa-icon><span>({{vehicle.vehicleRentalNumber}})</span></div> -->
                  </div>
  
  
                  <div class="justify-content-center" *ngIf="vehicle.isAvailable">
                    <div class="price-container">
                      <div class="duration"> {{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                      <div class="vehicle-price">{{vehicle.vehiclePrice | number}} {{currency}}</div>
  
                    </div>
                    <div class="book-now">
                      <button class="btn btn-book-now" mat-button
                        (click)="onBookNowClicked(vehicle)">{{ 'BookNowButton' | translate }}</button>
                    </div>
                    <div class="show-tax-and-charges">
                      <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class=""><i class="fab fa-creative-commons-nc mr-1"></i></span>
                      <span *ngIf="vehicle.shownPricesIncludeTax" class="">{{ 'Tax' | translate }} </span>
                      <span *ngIf="vehicle.shownPricesIncludeTax && vehicle.includeMandatoryCharges" class="">{{ 'and' | translate }} </span>
                      <span *ngIf="vehicle.includeMandatoryCharges" class="">{{ 'MandatoryCharges' | translate }} </span>
                      <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class="">{{ 'Inclusive' | translate }} </span>
                    </div>
                   
                  </div>
                  <div class="no-available-vehicle" *ngIf="!vehicle.isAvailable">
                    <span>{{ 'Vehicleisnotavailable' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- make/model/year -->
  
            <!-- vehicle -->
            <div *ngIf="vehicle.vehicleSearch">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="car-image">
                    <img class="img-fluid"
                    [src]="attachmentService
                    .getImageLink(vehicle.vehicleID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage)"
                    [alt]="vehicle.vehicleName"
                      (click)="onVehicleImageClicked(vehicle)">
                  </div>
  
                  <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                    <div class="car-details d-flex">
                      <div class="car-rank"><span class="badge badge-pill badge-primary">
                          <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                        <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                      <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                      </div>
                    </div>
                  </button>
                </div>
                <div class="col-lg-6  col-md-6 col-12 border-right">
                  <div class="d-flex">
                    <div class="vehicle-name mr-auto">
                      {{vehicle.makeModelYearName}}
                    </div>
                    <div class="vehicle-top-list  d-flex align-items-top">
                      <div class="vehicle-class">
                        {{vehicle.vehicleClass}}
                      </div>
                    </div>
                  </div>
  
                  <div class="vehicle-features">
                    <div class="row mt-2">
                      <!-- vehicle Gear Type-->
                      <div class="col-md-4  col-4 d-flex  align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehicleGearType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Condition Unit -->
                      <div class="col-md-4  col-4 d-flex align-items-top">
                        <span>
                          <mat-icon ngbPopover="{{ 'ACUnit' | translate }}" triggers="mouseenter:mouseleave"
                            class="fa-s mr-1">
                            ac_unit</mat-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.hasAirConditions?'Yes':'No'}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Petrol Type -->
                      <div class="col-md-4 col-4  d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faGasPump"></fa-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehiclePetrolType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Passengers Number -->
                      <div class="col-md-4  col-4 d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faUser"></fa-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehiclePassengersNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Doors Number -->
                      <div class="col-md-4  col-4 d-flex align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehicleDoorsNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Storage -->
                      <div class="col-md-4  col-4 d-flex align-items-top">
                        <span>
                          <mat-icon ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                            class="fa-s luggage mr-1">luggage</mat-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehicleStorage}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Number -->
                      <div class="col-md-4  col-4 d-flex align-items-top">
                        <span>
                          <fa-icon ngbPopover="{{ 'PlateNumber' | translate }}" triggers="mouseenter:mouseleave"
                            class="mr-1 vehicleNumber" [icon]="faCar"></fa-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.plateNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Odometer -->
                      <div class="col-md-4 col-4 d-flex align-items-top">
                        <span>
                          <fa-icon ngbPopover="{{ 'Odometer' | translate }}" triggers="mouseenter:mouseleave"
                            class="mr-1 faRoad" [icon]="faRoad"></fa-icon>
                        </span>
                        <div>
                          <ul class="vehicle-inner-list">
                            <li>{{vehicle.vehicleOdometer}}</li>
                          </ul>
                        </div>
                      </div>
  
  
                      <!-- vehicle Search-->
                      <div class="col-md-4 col-4 d-flex align-items-top">
                        <div class="car-colors d-flex justify-content-center">
                          <ul>
                            <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                              <!-- <div *ngIf="color.ExtericColor !=null">
                                <div class="color-box mr-1" [style.background-color]="color.ExtericColor"></div>
                              </div>
                              <div *ngIf=" color.ExtericColor ==null">
                                <div class="color-box mr-1" [style.background-color]="color"></div>
                              </div> -->
                              <div class="color-box mr-1" [style.background-color]="color.ExtericColor"></div>
                            </li>
                          </ul>
                        </div>
                      </div>
  
                    </div>
                    <div class="row mb-2 mt-2">
                      <div class="col-md-12 location-line d-flex align-items-top">
                        <fa-icon ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s"
                          [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.fromAgencyName}} - {{vehicle.vehicleLocation}}
                      </div>
                    </div>
                    <!-- <div *ngIf="vehicle.hasPromotion;">
                      <div class="promotion-box  mb-3">
                        <div class="promotion-icon d-flex align-items-center">
                          <fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:
                        </div>
                        <ul class="mb-0">
                          <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
                        </ul>
                      </div>
                    </div> -->
                    <div class="promotion-box mb-3" *ngIf="vehicle.campaignsReservationCaseModel!=null&&vehicle.campaignsReservationCaseModel.campaignName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" [attr.data-target]="'#collapseExample2_'+i" [attr.aria-controls]="'collapseExample2_'+i" aria-expanded="false" >
                        <i class="fas fa-gift promotion-icon mr-1 mt-1"></i> {{vehicle.campaignsReservationCaseModel.campaignName}}: {{'Expires' | translate}} {{vehicle.campaignsReservationCaseModel.endDateFormated}} {{vehicle.campaignsReservationCaseModel.discount}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample2_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.campaignsReservationCaseModel.campaignAdditionalServices!=null&&vehicle.campaignsReservationCaseModel.campaignAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5  *ngIf="vehicle.campaignsReservationCaseModel.campaignFreePolicies!=null&&vehicle.campaignsReservationCaseModel.campaignFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="promotion-box mb-3" *ngIf="vehicle.membershipModel!=null&&vehicle.membershipModel.membershipName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" data-toggle="collapse" [attr.data-target]="'#collapseExample2_'+i" [attr.aria-controls]="'collapseExample2_'+i" aria-expanded="false">
                        <i class="fas fa-award promotion-icon mr-1 mt-1"></i> {{vehicle.membershipModel.membershipName}} {{ 'Membership' | translate }} : {{ 'Discount' | translate }}  {{vehicle.membershipModel.discountValue}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample2_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.membershipModel.lstMembershipAdditionalServices!=null&&vehicle.membershipModel.lstMembershipAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstMembershipAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5 *ngIf="vehicle.membershipModel.lstCustomerMembershipFreePolicies!=null&&vehicle.membershipModel.lstCustomerMembershipFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstCustomerMembershipFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <policies-icons [policyRequestModel]="vehicle"></policies-icons>
  
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="d-flex">
                    <div class="favorite ml-auto" >
                      <button mat-icon-button (click)="toggleFavorite(vehicle)">
                        <mat-icon [ngClass]=" vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                          *ngIf="vehicle.isFavorite">favorite</mat-icon>
                        <mat-icon [ngClass]=" !vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                          *ngIf="!vehicle.isFavorite">favorite_border</mat-icon>
                      </button>
                    </div>
                    <!-- <div>
                      <fa-icon class="mr-1 grey" ngbPopover="{{ 'TotalRental' | translate }}" triggers="mouseenter:mouseleave"
                        [icon]="faKey"></fa-icon><span>({{vehicle.vehicleRentalNumber}})</span>
                    </div> -->
                  </div>
  
  
  
                  <div class="justify-content-center" *ngIf="vehicle.isAvailable">
                    <div class="price-container">
                      <div class="duration"> {{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                      <div class="vehicle-price">{{vehicle.vehiclePrice | number}} {{currency}}</div>
  
                    </div>
                    <div class="book-now">
                      <button class="btn btn-book-now" mat-button
                        (click)="onBookNowClicked(vehicle)">{{ 'BookNowButton' | translate }}</button>
                    </div>

                  <div class="show-tax-and-charges">
                    <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class=""><i class="fab fa-creative-commons-nc mr-1"></i></span>
                    <span *ngIf="vehicle.shownPricesIncludeTax" class="">{{ 'Tax' | translate }} </span>
                    <span *ngIf="vehicle.shownPricesIncludeTax && vehicle.includeMandatoryCharges" class="">{{ 'and' | translate }} </span>
                    <span *ngIf="vehicle.includeMandatoryCharges" class="">{{ 'MandatoryCharges' | translate }} </span>
                    <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class="">{{ 'Inclusive' | translate }} </span>
                  </div>
                 


                  </div>
                  <div class="no-available-vehicle" *ngIf="!vehicle.isAvailable">
                    <span>{{ 'Vehicleisnotavailable' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- vehicle -->
  
            <!-- class -->
            <div *ngIf="vehicle.classSearch">
              <div class="row">
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="car-image mb-2">
                    <img class="img-fluid"
                    [src]="attachmentService
                    .getImageLink(vehicle.classID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.VehicleClassImg)"
                    [alt]="vehicle.vehicleName"
                      (click)="onVehicleImageClicked(vehicle)">
                  </div>
  
                  <button class="btnLink" (click)="openReviewDialog(vehicle)" *ngIf="vehicle.evaluationSummary!=null &&vehicle.evaluationSummary.evaluationLogsDetails.length>0">
                    <div class="car-details d-flex">
                      <div class="car-rank"><span class="badge badge-pill badge-primary">
                          <!--{{vehicle.vehicleRankNumber}}-->{{vehicle.evaluationSummary.average}}</span>
                        <!--{{vehicle.vehicleRankText}}--> {{vehicle.evaluationSummary.resourceName}}</div>
                      <div class="car-reviews ml-1"> ({{vehicle.evaluationSummary.countEvaluation}}) {{ 'Reviews' | translate }}
                      </div>
                    </div>
                  </button>
                </div>
                <div class="col-lg-6  col-md-6 col-12 border-right">
                  <div class="vehicle-class">
                    {{vehicle.vehicleClass}}
                  </div>
                  <!-- <div class="vehicle-class">
                    {{vehicle.vehicleClass}}
                  </div> -->
                  <div class="vehicle-features">
                    <div class="row mt-2">
                      <!-- vehicle Gear Type-->
                      <div class="col-md-4 mt-2 col-4 d-flex  align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'GearType' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-gear.svg' />
                        </span>
                        <div>
                          <ul *ngFor="let gearType of vehicle.vehicleGearTypeList" class="vehicle-inner-list">
                            <li>{{gearType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Condition Unit -->
                      <!--   <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span><mat-icon class="fa-s">ac_unit</mat-icon></span>
                        <div>
                          <ul *ngFor="let conditionUnit of vehicle.vehicleConditionUnit" class="vehicle-inner-list">
                            <li>{{conditionUnit}}</li>
                          </ul>
                        </div>
                      </div> -->
  
                      <!-- vehicle Petrol Type -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'FuelType' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faGasPump"></fa-icon>
                        </span>
                        <div>
                          <ul *ngFor="let petrolType of vehicle.vehiclePetrolTypeList" class="vehicle-inner-list">
                            <li>{{petrolType}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Passengers Number -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <fa-icon class="mr-1" ngbPopover="{{ 'PassengersNum' | translate }}" triggers="mouseenter:mouseleave"
                            [icon]="faUser"></fa-icon>
                        </span>
                        <div>
                          <ul *ngFor="let passengersNumber of vehicle.vehiclePassengersNumberList" class="vehicle-inner-list">
                            <li>{{passengersNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Doors Number -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <img placement="bottom" class="custom-icon gear-icon-modal mr-1" ngbPopover="{{ 'Doors' | translate }}" triggers="mouseenter:mouseleave" src='/assets/img/icons/car-door.svg' />
                        </span>
                        <div>
                          <ul *ngFor="let doorsNumber of vehicle.vehicleDoorsNumberList" class="vehicle-inner-list">
                            <li>{{doorsNumber}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle Storage -->
                      <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <span>
                          <mat-icon ngbPopover="{{ 'Luggage' | translate }}" triggers="mouseenter:mouseleave"
                            class="fa-s luggage mr-1">luggage</mat-icon>
                        </span>
                        <div>
                          <ul *ngFor="let storage of vehicle.vehicleStorageList" class="vehicle-inner-list">
                            <li>{{storage}}</li>
                          </ul>
                        </div>
                      </div>
  
                      <!-- vehicle colors -->
                      <!-- <div class="col-md-4 mt-2 col-4 d-flex align-items-top">
                        <div class="car-colors d-flex justify-content-center">
                          <ul>
                            <li class="d-inline" *ngFor="let color of vehicle.vehicleColors">
                              <div class="color-box mr-1" [style.background-color]="color"></div>
                            </li>
                          </ul>
                        </div>
                      </div> -->
  
                    </div>
                    <div class="row mb-3 mt-2">
                      <div class="col-md-12 d-flex location-line align-items-top">
                        <fa-icon ngbPopover="{{ 'Location' | translate }}" triggers="mouseenter:mouseleave" class="mr-1 fa-s"
                          [icon]="faMapMarkerAlt"></fa-icon>{{vehicle.fromAgencyName}} - {{vehicle.vehicleLocation}}
                      </div>
                    </div>
                    <!-- <div *ngIf="vehicle.hasPromotion;">
                      <div class="promotion-box  mb-3">
                        <div class="promotion-icon d-flex align-items-center">
                          <fa-icon class="mr-1 mt-1" [icon]="faTags"></fa-icon> {{vehicle.vehiclePromotionName}}:
                        </div>
                        <ul class="mb-0">
                          <li *ngFor="let promotion of vehicle.vehiclePromotions">{{promotion}}</li>
                        </ul>
                      </div>
                    </div> -->
                    <div class="promotion-box mb-3" *ngIf="vehicle.campaignsReservationCaseModel!=null&&vehicle.campaignsReservationCaseModel.campaignName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" [attr.data-target]="'#collapseExample3_'+i" [attr.aria-controls]="'collapseExample3_'+i" aria-expanded="false" >
                        <i class="fas fa-gift promotion-icon mr-1 mt-1"></i> {{vehicle.campaignsReservationCaseModel.campaignName}}: {{'Expires' | translate}} {{vehicle.campaignsReservationCaseModel.endDateFormated}} {{vehicle.campaignsReservationCaseModel.discount}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample3_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.campaignsReservationCaseModel.campaignAdditionalServices!=null&&vehicle.campaignsReservationCaseModel.campaignAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5  *ngIf="vehicle.campaignsReservationCaseModel.campaignFreePolicies!=null&&vehicle.campaignsReservationCaseModel.campaignFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.campaignsReservationCaseModel.campaignFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="promotion-box mb-3" *ngIf="vehicle.membershipModel!=null&&vehicle.membershipModel.membershipName!=null">
                      <button class="btn btn-icon" type="button" data-toggle="collapse" data-toggle="collapse" [attr.data-target]="'#collapseExample3_'+i" [attr.aria-controls]="'collapseExample3_'+i" aria-expanded="false">
                        <i class="fas fa-award promotion-icon mr-1 mt-1"></i> {{vehicle.membershipModel.membershipName}} {{ 'Membership' | translate }} : {{ 'Discount' | translate }}  {{vehicle.membershipModel.discountValue}}%
                      </button>
                      <div class="collapse" [id]="'collapseExample3_'+i">
                        <div class="card card-body">
                          <h5 *ngIf="vehicle.membershipModel.lstMembershipAdditionalServices!=null&&vehicle.membershipModel.lstMembershipAdditionalServices.length > 0">{{ 'AdditionalServices' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstMembershipAdditionalServices">{{item.serviceName | translate}}</li>
                          </ul>
                          <h5 *ngIf="vehicle.membershipModel.lstCustomerMembershipFreePolicies!=null&&vehicle.membershipModel.lstCustomerMembershipFreePolicies.length > 0">{{ 'FreePolicies' | translate }}</h5>
                          <ul class="mb-0">
                            <li *ngFor="let item of vehicle.membershipModel.lstCustomerMembershipFreePolicies">{{item.policyTypeName}}</li>
                          </ul>
                        </div>
                      </div>
                    </div>
  
                    <policies-icons [policyRequestModel]="vehicle"></policies-icons>
  
                  </div>
                </div>
                <div class="col-lg-3 col-md-3 col-12">
                  <div class="favorite" >
                    <button mat-icon-button (click)="toggleFavorite(vehicle)">
                      <mat-icon [ngClass]=" vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                        *ngIf="vehicle.isFavorite">favorite</mat-icon>
                      <mat-icon [ngClass]=" !vehicle.isFavorite ? 'isActiveFavorite' : 'notActiveFavorite'"
                        *ngIf="!vehicle.isFavorite">favorite_border</mat-icon>
                    </button>
                  </div>
  
                  <div class="justify-content-center" *ngIf="vehicle.isAvailable">
                    <div class="price-container">
                      <div class="duration"> {{ 'PriceFor' | translate }} {{vehicle.durationUnitName}}</div>
                      <div class="vehicle-price">{{vehicle.vehiclePrice | number}} {{currency}}</div>
  
                    </div>
                    <div class="book-now">
                      <button class="btn btn-book-now" mat-button
                        (click)="onBookNowClicked(vehicle)">{{ 'BookNowButton' | translate }}</button>
                    </div>
                    <div class="show-tax-and-charges">
                      <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class=""><i class="fab fa-creative-commons-nc mr-1"></i></span>
                      <span *ngIf="vehicle.shownPricesIncludeTax" class="">{{ 'Tax' | translate }} </span>
                      <span *ngIf="vehicle.shownPricesIncludeTax && vehicle.includeMandatoryCharges" class="">{{ 'and' | translate }} </span>
                      <span *ngIf="vehicle.includeMandatoryCharges" class="">{{ 'MandatoryCharges' | translate }} </span>
                      <span *ngIf="vehicle.includeMandatoryCharges || vehicle.shownPricesIncludeTax" class="">{{ 'Inclusive' | translate }} </span>
                    </div>
                   
                  </div>
                  <div class="no-available-vehicle" *ngIf="!vehicle.isAvailable">
                    <span>{{ 'Vehicleisnotavailable' | translate }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- class -->
  
          </div>
  
      </div>
      </div>
    </div>
  


    <!-- You have Not Added Favorite Rentals Yet-->

  </div>

  <div class="col-md-12">
    <div *ngIf="vehicles!=null && vehicles.length == 0">
      <div class="row">
        <div class="col-md-12 d-flex flex-column justify-content-center align-items-center">
          <div class="no-available-image">
          <!-- <img src='/assets/img/car-noavailable.svg' /> -->
          <i class="fas fa-car"></i>
          </div>
          <div class="no-available-text">
            <p>{{ 'YouhaveNotAddedFavoriteRentalsYet' | translate }}</p>
          </div>
          <!-- <div class="no-available-btn">
            <a href="/" class="btn btn-book-now mat-button">{{ 'SearchForRentals' | translate }}</a>
          </div> -->
        </div>
      </div>
    </div>
  </div>

</div>
